import { types } from "../../types/types";

const initialState = {
    data: {}
}


export const paymentApiData = (state = initialState, action) => {
    switch (action.type) {
        case types.paymentApiData:
            return {
                ...state,
                data: { ...action.payload }
            }
        default:
            return state;
    }
}